import { AppContext } from '@context/App';
import { useContext } from 'react';

export default function useAppContext() {
  return useContext(AppContext);
}
